import React, { useReducer } from "react"; // eslint-disable-line no-unused-vars
import * as consts from "../consts";
import { State } from "./state";

const initialState = {
  alerts: [],
  busy: true,
  searching: false,
  categories: [],
  searchResults: {
    totalCount: -1,
    charities: [],
    filter: {
      query: "",
      postalCode: "",
      categoryColumnName: "",
      continuationToken: null,
    },
  },
};

function reducer(state, action) {
  switch (action.type) {
    case consts.ACTION_ADD_ALERT:
      return { ...state, alerts: [...state.alerts, action.payload] };
    case consts.ACTION_DISMISS_ALERT: {
      let updatedAlerts = state.alerts.slice();
      updatedAlerts.shift();
      return {
        ...state,
        alerts: updatedAlerts,
      };
    }
    case consts.ACTION_SET_BUSY:
      return { ...state, busy: action.payload };
    case consts.ACTION_SET_SEARCHING:
      return {
        ...state,
        searching: action.payload,
        busy: action.payload ? state.busy : false,
      };
    case consts.ACTION_SET_CATEGORIES:
      return { ...state, categories: action.payload };
    case consts.ACTION_SET_SEARCH_RESULTS:
      return { ...state, searchResults: action.payload };
    default:
      return state;
  }
}

export function Provider(props) {
  const [state, dispatch] = useReducer(reducer, initialState);
  const value = { state, dispatch };
  return <State.Provider value={value}>{props.children}</State.Provider>;
}
